var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64461 6C5.11835 6 6.309 7.19167 6.309 8.66667C6.309 10.1417 5.11835 11.3333 3.64461 11.3333C2.17087 11.3333 0.980225 10.1417 0.980225 8.66667C0.980225 7.19167 2.17087 6 3.64461 6ZM9.97253 10C10.4142 10 10.8377 10.1756 11.15 10.4882C11.4623 10.8007 11.6378 11.2246 11.6378 11.6667C11.6378 12.1087 11.4623 12.5326 11.15 12.8452C10.8377 13.1577 10.4142 13.3333 9.97253 13.3333C9.53088 13.3333 9.10732 13.1577 8.79503 12.8452C8.48273 12.5326 8.30729 12.1087 8.30729 11.6667C8.30729 11.2246 8.48273 10.8007 8.79503 10.4882C9.10732 10.1756 9.53088 10 9.97253 10ZM10.3056 0C10.8304 0 11.3501 0.103463 11.835 0.304482C12.3199 0.505501 12.7605 0.800139 13.1316 1.17157C13.5027 1.54301 13.7971 1.98396 13.9979 2.46927C14.1988 2.95457 14.3022 3.47471 14.3022 4C14.3022 6.20833 12.512 8 10.3056 8C9.24562 8 8.22907 7.57857 7.47957 6.82843C6.73007 6.07828 6.309 5.06087 6.309 4C6.309 1.79167 8.09913 0 10.3056 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.cff1e281.svg";
export { ForwardRef as ReactComponent };